import {Nullable} from "../../../../types";

export enum AdminUserField {
    ID = "id",
    EMAIL = "email",
    FIRST_NAME = "firstName",
    LAST_NAME = "lastName",
    PHONE = "phone",
    LANGUAGE = "language",
    MOBILE_PHONE = "mobilePhone",
    TIME_ZONE = "timeZone",
}

export interface AdminUser {
    [AdminUserField.ID]: number;
    [AdminUserField.EMAIL]: string;
    [AdminUserField.FIRST_NAME]: string;
    [AdminUserField.LAST_NAME]: string;
    [AdminUserField.PHONE]: string;
    [AdminUserField.LANGUAGE]: string;
    [AdminUserField.MOBILE_PHONE]?: Nullable<string>;
    [AdminUserField.TIME_ZONE]?: Nullable<string>;
}
